import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { terrainCodes } from "@/lib/routeSync";

// Cartes VAC du briefing : terrains de la route + ajouts manuels − exclusions.
export function selectedVacCodes(b) {
  const excluded = b.vacExcluded || [];
  const list = [...terrainCodes(b), ...(b.vacAdded || [])];
  return [...new Set(list)].filter((c) => !excluded.includes(c));
}

export function candidateVacCodes(b) {
  return [...new Set([...terrainCodes(b), ...(b.vacAdded || [])])];
}

export function useVacLibrary() {
  const [charts, setCharts] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    try { setCharts((await api.get("/vac-charts")).data); } catch { setCharts([]); } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);
  return { charts, loading, reload: load, byCode: Object.fromEntries(charts.map((c) => [c.icao, c])) };
}

export const frDate = (d) => (d ? d.split("-").reverse().join("/") : "—");
